<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <drivers-field-edit-form
        @on-submit="onDriverFieldEditSubmit"
      ></drivers-field-edit-form>
    </div>
  </div>
</template>
<script>
import DriversFieldEditForm from "./DriversFieldEditForm.vue";

export default {
  components: {
    DriversFieldEditForm
  },
  data() {
    return {
      holidayEditModel: {}
    };
  },
  methods: {
    onDriverFieldEditSubmit(model) {
      this.holidayEditModel = model;
      // this.$http.post(
      //   this.$apiBaseUrl + 'holidayss/' + this.holidayEditModel.id, Object.assign(this.holidayEditModel)
      // ).then(response => {
      // }, response => {
      // });
    }
  }
};
</script>
<style></style>
